import { batch } from 'react-redux';
import { fetchTenant } from '../../Organizations/OrganizationsSlice/actionCreators';
import { setGDIsLoading, setGroupDetail, setGroupMembers, setIsError } from '.';
import { fetchAllGroupMembers, getGroupById } from '../../../api/groups';
import type { AppThunk } from '../../../store';

export const fetchGroupDetail =
  ({ id }: { id: number }): AppThunk =>
  async (dispatch, getState) => {
    try {
      dispatch(setGDIsLoading({ all: true }));

      let tenant = getState().organizations.tenant;
      if (!tenant) {
        await dispatch(fetchTenant());
        tenant = getState().organizations.tenant;
        if (!tenant) {
          throw new Error('Missing tenant');
        }
      }

      const groupResult = await getGroupById({ groupId: id, tenantId: tenant.id });

      if (groupResult.error) {
        throw new Error();
      }
      const members = await fetchAllGroupMembers({ groupId: id, tenantId: tenant.id });
      batch(() => {
        dispatch(setGroupDetail(groupResult.data.data));
        dispatch(setGroupMembers(members));
        dispatch(setGDIsLoading({ all: false }));
      });
    } catch (error) {
      console.log('error log ', error);
      batch(() => {
        dispatch(setGDIsLoading({ all: false }));
        dispatch(setIsError(`${error}`));
      });
    }
  };
